import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Select, Button} from 'semantic-ui-react';
import {map, forEach, filter, isEmpty, isEqual} from 'lodash';
import moment from 'moment';
import {BUTTONS_BOTTOM, MONEY, UNITS, SALES, AVERAGE} from '../../constants';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {montsSelect} from '../../../common/constants/months';
import {yearsOptions} from '../../../common/constants/years';
import {IccOptions} from '../../../common/constants/lists';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {sumValues, averageMoneyBySales, filterByletters,
  avergageMoneyBySalesLetters, parseAverageDataTotal} from '../../util';
import Loader from '../../../common/components/loader';
import ChartIcc from './chart';
import './chartByLetters.scss';

class IccCharBytLetters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'year': moment().year(),
      'month': moment().month(),
      'title': MONEY,
      'letters': {},
      'selectBtn': MONEY,
      'data': [],
      'dataSales': [],
      'dataStock': [],
      'type': true,
      'copyDataType': [],
      'filterParam': '',
      'disabledAverage': false,
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.SmByicc, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    const {year, month} = this.state;
    const CURRENT_MONTH = month + 1;
    this.props.getLetters();
    this.props.getIccStock(year, CURRENT_MONTH);
    this.props.getIccSales(year, CURRENT_MONTH);
    this.setState({
      'letters': this.props.letters,
      'valueLetters': this.props.valueLetters,
      'data': this.props.info,
      'copyDataType': this.props.info,
      'dataSales': this.props.sales,
      'dataStock': this.props.stock,
    });
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.info, this.props.info)) {
      const {info, sales, stock, valueLetters, letters} = this.props;
      this.setState({
        'letters': letters,
        'valueLetters': valueLetters,
        'data': info,
        'copyDataType': info,
        'dataSales': sales,
        'dataStock': stock,
        'selectBtn': MONEY,
        'title': MONEY,
        'filterParam': '',
        'type': true,
        'totalAverageArr': [],
      });
    }
  }

  handleSelect(name, value) {
    this.setState({[name]: value});
  }

  handleSearch() {
    const {year, month} = this.state;
    const CURRENT_MONTH = month + 1;
    this.setState({
      'letters': this.props.letters,
      'valueLetters': this.props.valueLetters,
    });
    this.props.getIccStock(year, CURRENT_MONTH);
    this.props.getIccSales(year, CURRENT_MONTH);
  }

  handleStateBtnActive(element) {
    const label = element.toUpperCase();
    const filter = label === AVERAGE ? 'REPUESTOS' : '';
    const data = this.selectTypeByLabels(label, filter);
    this.setState({
      'selectBtn': element,
      'title': element,
      'data': data,
      'copyDataType': data,
      'type': true,
      'disabledAverage': element === AVERAGE ? true : false,
    }, () => {
      this.handleFilter(filter);
      this.handleClearLetters();
    });
  }

  handleSetLetterState(letter) {
    const {letters, selectBtn, filterParam} = this.state;
    const label = selectBtn.toUpperCase();
    const newLetters = {...letters};
    newLetters[letter].active = !newLetters[letter].active;
    const activeLetters = filter(newLetters, (l) => l.active);
    const data = isEmpty(activeLetters) ? this.selectTypeByLabels(label, filterParam) :
      this.selectTypeByLetters(label, filterParam, activeLetters);
    this.setState({
      'letters': newLetters,
      'data': data,
      'type': isEmpty(activeLetters) ? true : false,
    });
  }

  handleFilter(filterParam) {
    const {selectBtn, type} = this.state;
    const label = selectBtn.toUpperCase();
    let data = [];
    if (type) {
      data = this.selectTypeByLabels(label, filterParam);
    } else {
      data = this.selectTypeByLetters(label, filterParam);
    }
    this.setState({filterParam, data});
  }

  selectTypeByLabels(label, filterParam = '') {
    const {dataStock, dataSales} = this.state;
    let data = [];
    if (label === SALES) {
      data = sumValues(dataSales, label, filterParam);
    } else if (label === MONEY || label === UNITS) {
      data = sumValues(dataStock, label, filterParam);
    } else {
      data = averageMoneyBySales(dataStock, dataSales, filterParam);
    }
    return data;
  }

  selectTypeByLetters(label, filterParam, actLetters) {
    const {dataStock, dataSales, letters} = this.state;
    let data = [];
    const activeLetters = actLetters ? actLetters : filter(letters, (l) => l.active);
    if (label === MONEY || label === UNITS) {
      data = filterByletters({'data': dataStock, filterParam}, label, activeLetters);
    } else if (label === SALES) {
      data = filterByletters({'data': dataSales, filterParam}, label, activeLetters);
    } else {
      data = avergageMoneyBySalesLetters({dataStock, dataSales, filterParam}, activeLetters);
    }
    return data;
  }

  handleClearLetters() {
    const {letters, copyDataType} = this.state;
    const newLetters = {};
    forEach(letters, (l) => {
      newLetters[l.letter] = {
        'letter': l.letter,
        'active': false,
      };
    });
    this.setState({
      'letters': newLetters,
      'data': copyDataType,
      'type': true,
    });
  }

  renderButtonsContainer(disabledAverage, letters) {
    return map(letters, (l) => (
      <button
        key={l.letter}
        disabled={disabledAverage}
        onClick={() => this.handleSetLetterState(l.letter)}
        className={l.active ? 'icc__budget icc-active' : ' icc__budget'}
      >
        {l.letter}
      </button>
    ));
  }

  renderButtonsBottom(selectBtn) {
    return BUTTONS_BOTTOM.map((element) => (
      <Button
        onClick={() => this.handleStateBtnActive(element)}
        key={element}
        basic={selectBtn === element ? false : true}
        size='small'
        color='black'
      >
        {element}
      </Button>
    ));
  }

  renderIccContent() {
    const {title, letters, selectBtn, data, type,
      filterParam, copyDataType, dataSales, dataStock, disabledAverage} = this.state;
    return (
      <Card raised fluid>
        <div className='icc__header-chart icc-pd'>
          <h3>{title} {disabledAverage && 'REPUESTOS'}{' '}</h3>
          <div className='icc__btn-container'>
            {this.renderButtonsContainer(disabledAverage, letters)}
            <Button
              disabled={disabledAverage}
              onClick={() => this.handleClearLetters()}
              basic
              size='small'
              className='ml-3'
              color='black'
            >
              LIMPIAR
            </Button>
          </div>
          <Select
            value={filterParam}
            onChange={(e, {value}) => this.handleFilter(value)}
            className='selector'
            placeholder='Filtros'
            disabled={disabledAverage}
            fluid
            options={IccOptions}
          />
        </div>
        <div className='icc-chart mb-1'>
          <ChartIcc
            data={data}
            totalSale={parseAverageDataTotal(dataStock, dataSales, selectBtn)}
            type={type}
            selectBtn={selectBtn}
            copyDataType={copyDataType}
          />
        </div>
        <div className='icc-controls'>{this.renderButtonsBottom(selectBtn)}</div>
      </Card>
    );
  }

  render() {
    const {loadingStock, loadingSales} = this.props;
    const {year, month} = this.state;
    const conditionLoading = loadingStock || loadingSales ? true : false;

    return (
      <div>
        <Card raised fluid>
          <div className='icc__header'>
            <h2>S/M by Icc</h2>
            <div className='icc__controls'>
              <Select
                className='mr-2'
                placeholder='Selección de mes'
                options={montsSelect}
                defaultValue={month}
                onChange={(e, {value}) => this.handleSelect('month', value)}
              />
              <Select
                className='mr-2'
                placeholder='Selección del año'
                options={yearsOptions}
                defaultValue={year}
                onChange={(e, {value}) => this.handleSelect('year', value)}
              />
              <Button
                className='mr-3'
                disabled={conditionLoading}
                onClick={() => this.handleSearch()}
                color='black'
              >
                Consultar
              </Button>
            </div>
          </div>
        </Card>
        {conditionLoading ? <Loader /> : this.renderIccContent()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const newLetters = {};
  const valueLetters = {};
  forEach(state.icc.letters, (l) => newLetters[l.letter] = {'letter': l.letter, 'active': false});
  forEach(state.icc.letters, (l) => valueLetters[l.letter] = {'letter': l.letter, 'value': 0});
  return {
    'permissions': state.session.permissions,
    'letters': newLetters,
    'valueLetters': valueLetters,
    'loadingStock': state.iccStock.loading,
    'loadingSales': state.iccSales.loading,
    'stock': state.iccStock.stock,
    'sales': state.iccSales.sales,
    'info': sumValues(state.iccStock.stock, MONEY),
  };
};

const {getLetters, getIccStock, getIccSales, navigateTo} = Actions;

export default connect(mapStateToProps, {
  getLetters,
  getIccStock,
  getIccSales,
  navigateTo,
})(IccCharBytLetters);
